<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">อัพโหลดไฟล์เรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6" class="pa-4">
        <div class="mobile_grid">
          <div class="ml-1">อัพโหลดไฟล์บาร์โค้ดใหม่</div>
        </div>
        <div class="grid_row">
          <div class="ma-6 d_none">
            <div class="ml-1">นำเข้าไฟล์ Excel</div>
          </div>
          <div class="mt-1 mr-1">
            <div class="mt-3 ml-2 mb-n1 d_mobile">นำเข้าไฟล์ Excel</div>
            <div class="d-flex">
              <v-file-input color="#86bc3a" ref="file" class="input_width" label="เลือกไฟล์" prepend-icon="mdi-microsoft-excel" v-model="file_csv" hide-details="auto" accept=".xls,.xlsx"></v-file-input>
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-4 ml-4" icon v-bind="attrs" v-on="on" :href="`${publicPath}pdf_barcode.pdf`" target="_blank">
                <v-icon color="#86bc3a">mdi-help-circle-outline</v-icon>
              </v-btn>
                </template>
                <span>ตัวอย่างวิธีการอัพโหลดไฟล์ บาร์โค้ด (คลิ้ก)</span>
              </v-tooltip>
            </div>
          </div>
          <div class="mt-3 text-right">
            <v-btn class="pa-6 grad-success-bg white--text btn_mobile" v-if="file_csv != null" @click="upload_data">อัพโหลดไฟล์</v-btn>
            <v-btn class="pa-6 grad-grey-bg white--text btn_mobile" v-else disabled>อัพโหลดไฟล์</v-btn>
          </div>
        </div>
      </v-card>
      <v-card elevation="6" class="mt-6 pa-4">
        <div class="mobile_grid">
          <div class="ml-1">ประวัติการอัพโหลดไฟล์บาร์โค้ด</div>
        </div>
        <div class="ma-2">
          <v-data-table :headers="header" :items="history_list" :footer-props="footer_Props" :items-per-page="item_page" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td class="hidden_line">{{ diffDateTH(dataDetail.item.created_at) }}</td>
                <td class="hidden_line">{{ dataDetail.item.username }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
      <v-dialog v-model="image_modal" max-width="900">
        <v-dialog v-model="image_modal" max-width="900">
          <v-card elevation="0">
            <div class="d-flex justify-end">
              <v-btn icon class="ma-4" @click="image_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-img :src="img_barcode"></v-img>
          </v-card>
        </v-dialog>
      </v-dialog>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import img_barcode from "@/assets/image_barcode.jpeg";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Count_barcode",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      loading_page: false,
      file_csv: null,
      history_list: [],
      overlay: false,
      img_barcode: img_barcode,
      alert_success: false,
      image_modal: false,
      item_page: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'วันที่',
          value: 'created_at',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ผู้อัพโหลดไฟล์',
          value: 'username',
          fixed: true,
          width: '200px',
        },
      ],
    }
  },
  methods: {
    diffDateTH(value) {
      const diff = value.split('/')
      const day = diff[0]
      const month = diff[1]
      const year = parseInt(diff[2])+ 543
      return day+'/'+month+'/'+year
    },
    upload_data() {
      let extall ="xls,xlsx";
      let file = this.file_csv.name;
      let ext = file.split('.').pop().toLowerCase();
      if(parseInt(extall.indexOf(ext)) < 0)
      {
        Swal.fire({
          text: 'อัพโหลดได้เฉพาะไฟล์ Excel หรือ (.xls, .xlsx)',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.file_csv = null
        })
      }
      else {
        let config = {
          header: {
            'Content-Type' : 'multipart/form-data'
          }
        }
        const fd = new FormData();
        fd.append('user_id', this.$store.state.userDetail.id);
        fd.append('username', this.$store.state.userDetail.name);
        fd.append('file_csv', this.file_csv, this.file_csv.name);
        if (this.file_csv != null) {
          this.overlay = true
          HTTP.post('/stocks/barcode', fd, config).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              Swal.fire({
                title: 'บันทึกข้อมูลเรียบร้อย !',
                icon: 'success',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then((res) => {
                if (res.isConfirmed === true) {
                  this.get_history()
                  this.file_csv = null
                }
                else {
                  this.get_history()
                  this.file_csv = null
                }
              })
            }
          })
        }else {
          Swal.fire({
            title: 'ไม่สามารถบันทึกได้ !',
            text: 'ไม่พบไฟล์ที่อัพโหลด !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.file_csv = null
          })
        }
      }
    },
    get_history() {
      HTTP.post('/stocks/barcodehistory')
          .then((res) => {
            if (res.data.success === true)  {
              this.history_list = res.data.object
            }
          })
    }
  },
  mounted() {
    this.get_history()
  }
}
</script>

<style scoped>
.grid_row {
  display: grid;
  grid-template-columns: 20% 50% 30%;
  grid-gap: 15px 0;
}
.input_width {
  width: 85%;
}
.d_mobile {
  display: none;
}
.btn_mobile {
  width: 95%;
}
@media only screen and (max-width: 1000px) {
  .grid_row {
    display: grid;
    grid-template-columns: 25% 50% 25%;
    grid-gap: 15px 0;
  }
  .input_width {
    width: 65%;
  }
  .btn_mobile {
    width: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_row {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .input_width {
    width: 100%;
  }
  .d_none {
    display: none;
  }
  .d_mobile {
    display: grid;
  }
}
</style>
